/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { MembroEntidade } from '../model/membro-entidade.model';
// @ts-ignore
import { PaginatedMembroEntidadeList } from '../model/paginated-membro-entidade-list.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CeiBaseApiService } from '@cei-ufg/ngx-arquitetura-cei-commons';
import {
    MembrosDeEntidadeApiServiceInterface,
    EntidadeMembrosCreateRequestParams,
    EntidadeMembrosDelegarPermissaoCreateRequestParams,
    EntidadeMembrosDelegarPermissaoDestroyRequestParams,
    EntidadeMembrosDestroyRequestParams,
    EntidadeMembrosListRequestParams,
    EntidadeMembrosPermissoesDelegadasRetrieveRequestParams,
    EntidadeMembrosRetrieveRequestParams,
    EntidadeMembrosUpdateRequestParams
} from './membros-de-entidade.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class MembrosDeEntidadeApiService extends CeiBaseApiService implements MembrosDeEntidadeApiServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super();
        this.initOpenApiLayer(basePath, configuration);
    }

    /**
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosCreate(requestParameters: EntidadeMembrosCreateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembroEntidade>;
    public entidadeMembrosCreate(requestParameters: EntidadeMembrosCreateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembroEntidade>>;
    public entidadeMembrosCreate(requestParameters: EntidadeMembrosCreateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembroEntidade>>;
    public entidadeMembrosCreate(requestParameters: EntidadeMembrosCreateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosCreate.');
        }
        const membroEntidade = requestParameters?.membroEntidade;

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembroEntidade>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: membroEntidade,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delegar permissão a membro
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosDelegarPermissaoCreate(requestParameters: EntidadeMembrosDelegarPermissaoCreateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembroEntidade>;
    public entidadeMembrosDelegarPermissaoCreate(requestParameters: EntidadeMembrosDelegarPermissaoCreateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembroEntidade>>;
    public entidadeMembrosDelegarPermissaoCreate(requestParameters: EntidadeMembrosDelegarPermissaoCreateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembroEntidade>>;
    public entidadeMembrosDelegarPermissaoCreate(requestParameters: EntidadeMembrosDelegarPermissaoCreateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosDelegarPermissaoCreate.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosDelegarPermissaoCreate.');
        }
        const membroEntidade = requestParameters?.membroEntidade;

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/delegar-permissao/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembroEntidade>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: membroEntidade,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revogar permissão delegada
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosDelegarPermissaoDestroy(requestParameters: EntidadeMembrosDelegarPermissaoDestroyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosDelegarPermissaoDestroy(requestParameters: EntidadeMembrosDelegarPermissaoDestroyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosDelegarPermissaoDestroy(requestParameters: EntidadeMembrosDelegarPermissaoDestroyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosDelegarPermissaoDestroy(requestParameters: EntidadeMembrosDelegarPermissaoDestroyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const codename = requestParameters?.codename;
        if (codename === null || codename === undefined) {
            throw new Error('Required parameter codename was null or undefined when calling entidadeMembrosDelegarPermissaoDestroy.');
        }
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosDelegarPermissaoDestroy.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosDelegarPermissaoDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/delegar-permissao/${this.configuration.encodeParam({name: "codename", value: codename, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosDestroy(requestParameters: EntidadeMembrosDestroyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosDestroy(requestParameters: EntidadeMembrosDestroyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosDestroy(requestParameters: EntidadeMembrosDestroyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosDestroy(requestParameters: EntidadeMembrosDestroyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosDestroy.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosList(requestParameters: EntidadeMembrosListRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedMembroEntidadeList>;
    public entidadeMembrosList(requestParameters: EntidadeMembrosListRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedMembroEntidadeList>>;
    public entidadeMembrosList(requestParameters: EntidadeMembrosListRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedMembroEntidadeList>>;
    public entidadeMembrosList(requestParameters: EntidadeMembrosListRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosList.');
        }
        const page = requestParameters?.page;
        const pageSize = requestParameters?.pageSize;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page_size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedMembroEntidadeList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar permissões delegadas ao membro
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosPermissoesDelegadasRetrieve(requestParameters: EntidadeMembrosPermissoesDelegadasRetrieveRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembroEntidade>;
    public entidadeMembrosPermissoesDelegadasRetrieve(requestParameters: EntidadeMembrosPermissoesDelegadasRetrieveRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembroEntidade>>;
    public entidadeMembrosPermissoesDelegadasRetrieve(requestParameters: EntidadeMembrosPermissoesDelegadasRetrieveRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembroEntidade>>;
    public entidadeMembrosPermissoesDelegadasRetrieve(requestParameters: EntidadeMembrosPermissoesDelegadasRetrieveRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosPermissoesDelegadasRetrieve.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosPermissoesDelegadasRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/permissoes-delegadas/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembroEntidade>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosRetrieve(requestParameters: EntidadeMembrosRetrieveRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembroEntidade>;
    public entidadeMembrosRetrieve(requestParameters: EntidadeMembrosRetrieveRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembroEntidade>>;
    public entidadeMembrosRetrieve(requestParameters: EntidadeMembrosRetrieveRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembroEntidade>>;
    public entidadeMembrosRetrieve(requestParameters: EntidadeMembrosRetrieveRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosRetrieve.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembroEntidade>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * API nested de membros por entidade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosUpdate(requestParameters: EntidadeMembrosUpdateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembroEntidade>;
    public entidadeMembrosUpdate(requestParameters: EntidadeMembrosUpdateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembroEntidade>>;
    public entidadeMembrosUpdate(requestParameters: EntidadeMembrosUpdateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembroEntidade>>;
    public entidadeMembrosUpdate(requestParameters: EntidadeMembrosUpdateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entidadeId = requestParameters?.entidadeId;
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosUpdate.');
        }
        const pessoaId = requestParameters?.pessoaId;
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosUpdate.');
        }
        const membroEntidade = requestParameters?.membroEntidade;

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembroEntidade>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: membroEntidade,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
